import React from 'react'
import { Link } from 'react-router'

import getPath from '../../../shared/utils/getPath'

const Logo = () => {
  return (
    <div className="logo fixed">
      <Link
        to={getPath('frontend')}
        title="Zurück zur Startseite"
      >
        <img
          className="logo-musbi"
          src="/static/images/svg/musbi-logo.svg"
          alt="MusBi, Museum bildet"
        />
      </Link>
    </div>
  )
}

export { Logo as default }



// WEBPACK FOOTER //
// ./src/frontend/base/components/Logo.js